/*
 * @Author: sybil.chen
 * @Date: 2023-02-08 15:46:35
 * @LastEditTime: 2023-02-13 14:19:36
 * @LastEditors: sybil.chen
 * @Description: https://www.figma.com/file/HqxEAHWKuGYIUAQqIQUTYD/%E3%80%8CWeb%E3%80%8D%E4%BC%81%E4%B8%9A%E7%89%88%E4%B8%AD%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F?node-id=74777%3A103053&t=9Zs1bGIKXB0gJsoY-0
 */

import { DatePicker } from 'antd';
import type { TimeRangePickerProps } from 'antd';
import IconFont from '../IconFont';
import classNames from 'classnames';
import styles from './index.less';

interface ResetRangePickerProps extends TimeRangePickerProps {
  test?: string;
}

const IconStyle = {
  color: '#656C85',
  fontSize: '14px',
};
const customNextIcon = () => (
  <IconFont style={IconStyle} type='ic-chenxian_you' />
);
const customPrevIcon = () => (
  <IconFont style={IconStyle} type='ic-chenxian_zuo' />
);
const customSuffixIcon = () => (
  <IconFont style={IconStyle} type='ic-chenxian_rili' />
);
const customSuperNextIcon = () => (
  <IconFont style={IconStyle} type='ic-chenxian_tiaozhuanzhiweiye' />
);
const customSuperPrevIcon = () => (
  <IconFont style={IconStyle} type='ic-chenxian_tiaozhuanzhishouye' />
);
const customSeparator = () => (
  <IconFont style={IconStyle} type='ic-chenxian_xiangyou' />
);

const ResetRangePicker = (props: ResetRangePickerProps) => {
  return (
    <DatePicker.RangePicker
      {...props}
      dropdownClassName={styles['custom-dropdown-range-picker']}
      className={classNames(props.className, styles['custom-range-picker'])}
      nextIcon={props.nextIcon || customNextIcon()}
      prevIcon={props.prevIcon || customPrevIcon()}
      suffixIcon={props.suffixIcon || customSuffixIcon()}
      superNextIcon={props.superNextIcon || customSuperNextIcon()}
      superPrevIcon={props.superPrevIcon || customSuperPrevIcon()}
      separator={props.separator || customSeparator()}
    ></DatePicker.RangePicker>
  );
};

export default ResetRangePicker;
